<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBluetooth_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.888 5.002a.7.7 0 0 0-.05-1.049L8.341 1.157A.7.7 0 0 0 7.2 1.7v4.61L4.195 3.305a.7.7 0 0 0-.99.99L6.91 8l-3.705 3.705a.7.7 0 0 0 .99.99L7.2 9.69v4.604a.701.701 0 0 0 1.142.55l3.487-2.791a.698.698 0 0 0 .058-1.055l-2-2L8.89 8l2.998-2.998ZM8.6 9.69v3.154l1.752-1.402-1.131-1.131L8.6 9.69Zm0-6.534V6.31l1.752-1.752L8.6 3.156Z"
        clip-rule="evenodd"
    />
</svg>
